export default "__VITE_ASSET__BJ52Z6R0__"